<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import AnswerFileFullScreen from '@views/question-review/components/AnswerFileFullScreen'
import ContextMenu from '@views/question-review/components/ContextMenu'
import CropperImage from '@views/question-review/components/CropperImage'
import LableResult from '@views/question-review/components/LableResult'
import ReviewBox from '@views/question-review/components/ReviewBox'
import UploadFile from '@views/question-review/components/UploadFile'
import UploadImage from '@views/question-review/components/UploadImage'

export default {
  components: {},
  provide () {
    return {}
  },
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {
    AnswerFileFullScreen.destroy()
    ContextMenu.destroy()
    CropperImage.destroy()
    LableResult.destroy()
    ReviewBox.destroy()
    UploadFile.destroy()
    UploadImage.destroy()
  },
  methods: {},
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/QuestionReview/src/QuestionReview.vue